module.exports = __webpack_public_path__ + "img/subchapter-back.e3bc7f9b.png";